import { css, Stack, styled, Typography } from '@mui/material';

export const SContainer = styled(Stack)(
  ({ theme }) => css`
    display: none;

    ${theme.breakpoints.up('laptop')} {
      display: flex;
      gap: 20px;
      background: ${theme.palette.grey[100]};
      justify-content: center;
      align-items: center;
    }

    ${theme.breakpoints.up('desktop')} {
      display: flex;
      padding: 80px 72px;
      background: ${theme.palette.grey[100]};
      justify-content: center;
      align-items: center;
    }
  `,
);

export const STitle = styled(Typography)(
  () => css`
    font-size: 36px;
    font-weight: 500;
    line-height: 40px;
    letter-spacing: 0;
    text-align: left;
  `,
);

export const SInfoBlock = styled(Stack)(
  ({ theme }) => css`
    background: ${theme.palette.common.white};
    border-radius: 12px;
    width: 557px;
  `,
);

export const SInfoContentBlock = styled(Stack)(
  () => css`
    padding: 32px 24px 24px;
    transition: opacity 0.5s ease-out;
    width: 557px;
    height: 460px;
    justify-content: space-between;
  `,
);
